document.addEventListener("DOMContentLoaded", function () {
  const wrappers = document.querySelectorAll('.mega-menu-wrapper');

  wrappers.forEach(wrapper => {
    const allPromos = wrapper.querySelectorAll('.mega-menu-promo-block');
    const links = wrapper.querySelectorAll('.mega-menu__link--parent');
    const rightSide = wrapper.querySelector('.mega-menu-right');
    
    // Function to pass the height as a CSS variable
    const syncHeightVariable = (activeColumn) => {
      if (!rightSide) return;

      const submenu = activeColumn.querySelector('.mega-menu__submenu');
      if (submenu) {
        // Get the height
        const heightValue = submenu.scrollHeight + "px";
        // Set the CSS Variable --min-height on the rightSide element
        rightSide.style.setProperty('--min-height', heightValue);
      } else {
        // Reset variable if no submenu
        rightSide.style.setProperty('--min-height', '400px'); 
      }
    };

    const showPromo = (handle) => {
      allPromos.forEach(p => p.style.display = 'none');
      let target = wrapper.querySelector(`.mega-menu-promo-block[data-handle="${handle}"]`);
      
      if (!target || handle === "") {
        target = wrapper.querySelector('.mega-menu-promo-block[data-handle="default"]');
      }
      if (target) target.style.display = 'grid';
    };

    links.forEach(link => {
      link.addEventListener('mouseenter', function () {
        const handle = this.getAttribute('data-mega-trigger');
        const column = this.closest('.mega-menu__column');
        
        wrapper.querySelectorAll('.mega-menu__column').forEach(col => col.classList.remove('is-active'));
        column.classList.add('is-active');

        showPromo(handle);
        syncHeightVariable(column);
      });
    });

    wrapper.addEventListener('mouseleave', function () {
      wrapper.querySelectorAll('.mega-menu__column').forEach(col => col.classList.remove('is-active'));
      showPromo('default');
      // Reset variable to a base value on leave
      rightSide.style.setProperty('--min-height', '400px');
    });
  });
});